module.exports = __webpack_public_path__ + "img/update_grid.45303072.png";